import { useState, useEffect} from "react";
import { Link} from "react-scroll";

import styles from './NavBar.module.css'
import StickyContainer from "components/StickyContainer";

const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

type props = {
  closeMenu: any,
  alphabetisedLocations: object
}

const NavItems = ({ closeMenu, alphabetisedLocations }: props) => (
  <ul>
    {alphabet.map((letter) => {
      if (alphabetisedLocations[letter.toLocaleUpperCase()])
        return (
          <li key={letter}>
            <Link to={`startsWith_${letter}`} smooth={true} offset={-200} duration={500} onClick={closeMenu}>
              {letter.toUpperCase()}
            </Link>
          </li>
        );
      else
        return (
          <li key={letter}>
            <p>{letter.toUpperCase()}</p>
          </li>
        );
    })}
  </ul>
);

const NavBar = (props) => {
  const [windowWidth, updateWindowWidth] = useState(0);

  const updateWindow = () => {
    updateWindowWidth(window.innerWidth);
  };

  const closeMenu = (e) => {
    if (props.menuVisible) {
      props.closeMenu();
    }
  };

  useEffect(() => {
    updateWindow();
    window.addEventListener("resize", updateWindow);

    return () => {
      window.removeEventListener("resize", updateWindow);
    };
  });

  useEffect(() => {
    let overlay = document.getElementById('overlay');
    let menu = document.getElementById('cr-NEW-menu');
    if(overlay && menu) {
      if (props.menuVisible) {
        overlay.style.opacity = '1';
        menu.style.opacity = '1';
      } else {
        overlay.style.opacity = '0';
        menu.style.opacity = '0';
      }
    }
    
  }, [props.menuVisible]);

  if (windowWidth >= 968)
    return (
      <StickyContainer offsetFromTop={75}>
        <section className={styles.Background}>
          <div className={styles.Container}>
            <NavItems {...props} closeMenu={closeMenu} />
          </div>
        </section>
      </StickyContainer>
    );

  return (
    <>
      <div className={styles.Overlay}
        id="overlay"
        style={{
          display: props.menuVisible ? "block" : "none",
        }}
        onClick={(e) => {
          props.closeMenu();
        }}
      />
      <section className={styles.SideMenu}
        id="cr-NEW-menu"
        style={{
          display: props.menuVisible ? "block" : "none",
        }}
      >
        <NavItems {...props} closeMenu={closeMenu} />
      </section>
    </>
  );
};

export default NavBar;
